import { Component } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { HeaderBannerComponent } from 'src/app/shared/components/header-banner/header-banner.component';
import { StartPlaningMobileComponent } from 'src/app/shared/components/start-planing-mobile/start-planing-mobile.component';

@Component({
  selector: 'app-terms-n-conditions',
  imports: [
    TranslateModule,
    KeyValuePipe,
    HeaderBannerComponent,
    StartPlaningMobileComponent,
  ],
  templateUrl: './terms-n-conditions.component.html',
  styleUrl: './terms-n-conditions.component.scss',
})
export class TermsNConditionsComponent {
  public titlePath: string = 'TERMS_N_CONDITIONS.TITLE';
  public rulesPath: string = 'TERMS_N_CONDITIONS.RULES';

  constructor(private readonly route: ActivatedRoute) {
    this.route.paramMap.subscribe((params) => {
      if (params.has('lang')) {
        this.titlePath = 'HE_TERMS_N_CONDITIONS.TITLE';
        this.rulesPath = 'HE_TERMS_N_CONDITIONS.RULES';
      }
    });
  }
}
